import {useEffect} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {Button, Col, Container, Image, Row} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import students from "../../images/Learning languages-cuate.svg";
import studentgrades from "../../images/Grades-cuate.png";
import bookmarks from "../../images/Bookmarks-cuate.svg"
import "./hero.css";
import {Footer} from "../Footer";

const Hero = () => {
    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('fade-in');
                }
            });
        }, {threshold: 0.2});

        const elements = document.querySelectorAll('.fade-in-element');
        elements.forEach(element => observer.observe(element));

        return () => observer.disconnect();
    }, []);

    return (
        <>
            <div className="hero-section">
                <Container>
                    <Row className={"m-2 m-md-3 p-4 p-md-5 align-items-center fade-in"}>
                        <Col xs={12} md={7} className="mb-5 mb-md-0">
                            <div className="text-start">
                                <h1 className="display-2 rubik-text hero-heading mb-4">
                                    <span className="gradient-text">Σημειώσεις από κάθε γωνιά της Ελλάδας, στα χέρια σου!</span>
                                </h1>
                                <p className="lead rubik-text text-secondary mb-4 fs-4" style={{fontWeight: 400}}>
                                    Η μεγαλύτερη φοιτητική κοινότητα ανταλλαγής σημειώσεων. Βρες ό,τι χρειάζεσαι για τις
                                    σπουδές σου, εύκολα και γρήγορα.
                                </p>
                                <Link to={"/folder/1"}>
                                    <Button
                                        className="btn-lg px-5 py-3 rounded-pill mainbutton rubik-text shadow button-hover-effect"
                                        style={{background: 'var(--carrot-orange)', border: "none"}}>
                                        Μπες τώρα, δωρεάν!
                                    </Button>
                                </Link>
                            </div>
                        </Col>
                        <Col xs={12} md={5} className="text-center">
                            <Image src={studentgrades} className="w-100 floating"
                                   style={{filter: 'drop-shadow(0 20px 30px rgba(0,0,0,0.1))'}}/>
                        </Col>
                    </Row>
                </Container>
            </div>

            <Container className="pb-5">
                <Row className="mb-5">
                    <Col md={4} className="mb-4">
                        <div className="hero-card h-100 fade-in-element stagger-1">
                            <div className="feature-icon">📚</div>
                            <h3 className="rubik-text">Διαλέξεις</h3>
                            <p className="text-muted">Πλήρεις σημειώσεις από παραδόσεις καθηγητών για κάθε μάθημα.</p>
                        </div>
                    </Col>
                    <Col md={4} className="mb-4">
                        <div className="hero-card h-100 fade-in-element stagger-2">
                            <div className="feature-icon">📝</div>
                            <h3 className="rubik-text">Παλιά Θέματα</h3>
                            <p className="text-muted">Προετοιμάσου για τις εξετάσεις με θέματα προηγούμενων ετών.</p>
                        </div>
                    </Col>
                    <Col md={4} className="mb-4">
                        <div className="hero-card h-100 fade-in-element stagger-3">
                            <div className="feature-icon">🎓</div>
                            <h3 className="rubik-text">300+ Τμήματα</h3>
                            <p className="text-muted">Κάλυψη για σχεδόν όλα τα τμήματα της τριτοβάθμιας εκπαίδευσης.</p>
                        </div>
                    </Col>
                </Row>

                <Row
                    className={"align-items-center m-2 m-md-3 p-4 p-md-5 rounded-5 fade-in-element hero-section-row mb-5"}
                    style={{backgroundColor: 'rgba(101, 199, 232, 0.1)', border: '1px solid rgba(101, 199, 232, 0.2)'}}>
                    <Col xs={12} md={6} className="order-2 order-md-1">
                        <Image src={bookmarks} alt="Notes" className="w-100"
                               style={{maxHeight: '400px', objectFit: 'contain'}}/>
                    </Col>
                    <Col xs={12} md={6} className={"p-4 order-1 order-md-2 mb-4 mb-md-0"}>
                        <h2 className="display-5 rubik-text mb-4" style={{color: 'var(--polynesian-blue)'}}>Αμέτρητο
                            ακαδημαϊκό υλικό</h2>
                        <p className="lead mb-4">Όλο το απαραίτητο υλικό συγκεντρωμένο σε ένα μέρος, οργανωμένο ανά
                            τμήμα και μάθημα.</p>
                        <ul className="list-unstyled fs-5">
                            <li className="mb-3"><span className="me-2"
                                                       style={{color: 'var(--shamrock-green)'}}>✓</span> Διαλέξεις &
                                Σημειώσεις
                            </li>
                            <li className="mb-3"><span className="me-2"
                                                       style={{color: 'var(--shamrock-green)'}}>✓</span> Λυμένες Ασκήσεις
                            </li>
                            <li className="mb-3"><span className="me-2"
                                                       style={{color: 'var(--shamrock-green)'}}>✓</span> Θέματα Εξετάσεων
                            </li>
                        </ul>
                    </Col>
                </Row>

                <Row className={"align-items-center m-2 m-md-3 p-4 p-md-5 rounded-5 fade-in-element hero-section-row"}
                     style={{backgroundColor: 'rgba(244, 156, 80, 0.1)', border: '1px solid rgba(244, 156, 80, 0.2)'}}>
                    <Col xs={12} md={6} className={"p-4 mb-4 mb-md-0"}>
                        <h2 className="display-5 rubik-text mb-4" style={{color: 'var(--carrot-orange)'}}>Πρόσβαση από παντού</h2>
                        <p className="lead mb-4">Μελέτησε από τον υπολογιστή, το tablet ή το κινητό σου, όπου κι αν
                            βρίσκεσαι. Η γνώση σε ακολουθεί παντού.</p>
                        <Link
                            to="/folder/1"
                            className="btn btn-outline-dark rounded-pill px-4"
                        >
                            Εξερεύνηση
                        </Link>
                    </Col>
                    <Col xs={12} md={6}>
                        <Image src={students} alt="Notes" className="w-100"
                               style={{maxHeight: '400px', objectFit: 'contain'}}/>
                    </Col>
                </Row>
            </Container>
            <Footer/>
        </>
    );
}

export default Hero;
